module.exports = __webpack_public_path__ + "static/img/beans.11d12b19.png";